import React from 'react';

const Svg = ({ icon, type, style, className = '', color = 'grey' }) =>
  icon ? <span style={style} className={`icon-${color} ${className}`} dangerouslySetInnerHTML={{ __html: icon[type] }} /> : null;

export default Svg;
